<template>
    <div>
        <slot name="navigation" :activeTrigger="activeTrigger"></slot>
        <slot name="content"></slot>
    </div>
</template>

<script>
    export default {
        name: 'Affix',
        props: ['defaultTrigger'],
        data() {
            return {
                showScrollToTop: false,
                showAffix: false,
                affixOffset: 0,
                triggers: [],
                activeTrigger: '',
                scrollTolerance: 100,
                scrollTimeout: 50,
                scrollTimedOut: false,
            }
        },
        mounted() {
            this.activeTrigger = this.defaultTrigger
            this.triggers      = this.$el.querySelectorAll('.affix-trigger')
            this.onScroll()
            window.addEventListener('scroll', this.onScroll, {passive: true});
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.onScroll, {passive: true});
        },
        methods: {

            onScroll() {
                let scrollBounds     = this.$slots.content[0].elm.getBoundingClientRect();
                this.showScrollToTop = (scrollBounds.top < 0);
                this.showAffix       = this.showScrollToTop;
                this.affixOffset     = (scrollBounds.bottom < 360)
                    ? Math.abs(scrollBounds.bottom - 360)
                    : 0

                if (this.scrollTimedOut) return // waiting for setTimeout() to finish

                // collect dimension info on each section and store in array for easy access
                let tops = []
                Array.prototype.forEach.call(this.triggers, trigger => {
                    tops.push({
                        top: trigger.getBoundingClientRect().top,
                        name: trigger.getAttribute('name')
                    })
                })

                // if we're not scrolled past the page title, don't calculate the active section since it should just be the first section
                if (window.scrollY < scrollBounds.top) {
                    this.activeTrigger = tops[0].name
                    this.timeoutScroll()
                    return
                }

                // calculate which of the sections is currently in the viewport
                let activeTrigger = tops[0].name
                for (let i = 0; i < tops.length; i++) {
                    let trigger         = tops[i]
                    let previousTrigger = tops[i - 1]
                    let nextTrigger     = tops[i + 1]
                    if (nextTrigger && previousTrigger) {
                        if (trigger.top < this.scrollTolerance &&
                            nextTrigger.top > this.scrollTolerance &&
                            previousTrigger.top < trigger.top &&
                            nextTrigger.top > trigger.top) {
                            activeTrigger = trigger.name
                            break
                        }
                    } else if (nextTrigger &&
                        trigger.top < this.scrollTolerance &&
                        nextTrigger.top > this.scrollTolerance &&
                        trigger.top < nextTrigger.top) {
                        activeTrigger = trigger.name
                        break
                    } else if (previousTrigger &&
                        trigger.top < this.scrollTolerance && trigger.top > previousTrigger.top) {
                        activeTrigger = trigger.name
                        break
                    }
                }

                this.activeTrigger = activeTrigger
                this.timeoutScroll()
            },
            timeoutScroll() {
                this.scrollTimedOut = true;
                setTimeout(function () {
                    this.scrollTimedOut = false
                }.bind(this), this.scrollTimeout)
            },
            scrollToTop() {
                this.$slots.content[0].elm.scrollIntoView();
            },
        },
    }
</script>


// WEBPACK FOOTER //
// Affix.vue?1bd8f71a